{
  "id": 1,
  "displayOrder": null,
  "parentId": null,
  "publishDate": null,
  "status": "PROTECTED",
  "identifiers": [
    {
      "id": 1,
      "pageId": 1,
      "zoneId": 1,
      "languageId": 1,
      "url": "default",
      "name": "Home",
      "description": "",
      "hidden": []
    }
  ],
  "meta": {
    "showInMenu": "true",
    "template": "",
    "theme": ""
  },
  "permissions": [],
  "zone": 1,
  "tags": [],
  "widgets": [
    {
      "id": 1,
      "pageId": 1,
      "widgetId": 1,
      "parentId": null,
      "displayOrder": 1,
      "data": {
        "columnsNormal": "full-width",
        "title": "container-fluid"
      },
      "permissions": [],
      "nodes": [],
      "content": [
        {
          "id": 190,
          "pageId": 1,
          "widgetId": 1,
          "parentId": 1,
          "displayOrder": 1,
          "data": {
            "columnsNormal": "full-width",
            "name": "Section",
            "sectionTracker": 0,
            "title": "section1"
          },
          "permissions": [],
          "nodes": [],
          "content": [
            {
              "id": 192,
              "pageId": 1,
              "widgetId": 42,
              "parentId": 190,
              "displayOrder": 1,
              "data": {
                "class": "block-pdf-wrapper",
                "col": 0,
                "emptyWriteTemplate": "",
                "firstName": "{{user.data.FIRST_NAME}}",
                "image": "\/api\/1.0\/download\/6?i=1",
                "image_url": "\/api\/1.0\/download\/6?i=1",
                "imageAlt": "A model in a dark pink jumper looks through a window",
                "logo": "\/api\/1.0\/download\/5?i=1",
                "name": "Hero Header",
                "row": 0,
                "sizeX": 12,
                "toggle": 1
              },
              "permissions": [],
              "nodes": [
                {
                  "id": 6,
                  "name": "hero-image.jpg",
                  "mime": "image\/jpeg",
                  "dateModified": 1641456807
                }
              ],
              "content": [],
              "widget": 42,
              "languageData": [],
              "hidden": [],
              "uid": 192,
              "identifier": "HERO-HEADER"
            }
          ],
          "widget": 1,
          "languageData": [],
          "hidden": [],
          "uid": 190,
          "identifier": "WRAPPER"
        },
        {
          "id": 255,
          "pageId": 1,
          "widgetId": 1,
          "parentId": 1,
          "displayOrder": 6,
          "data": {
            "columnsNormal": "full-width",
            "name": "Section",
            "sectionTracker": 5
          },
          "permissions": [],
          "nodes": [],
          "content": [
            {
              "id": 256,
              "pageId": 1,
              "widgetId": 47,
              "parentId": 255,
              "displayOrder": 1,
              "data": {
                "class": "block-pdf-wrapper",
                "col": 0,
                "emptyWriteTemplate": 1,
                "name": "Added Extras",
                "row": 0,
                "sizeX": 12,
                "toggle": ""
              },
              "permissions": [],
              "nodes": [],
              "content": [],
              "widget": 47,
              "languageData": [],
              "hidden": [],
              "uid": 256,
              "identifier": "TOTAL-REWARDS-SUMMARY"
            }
          ],
          "widget": 1,
          "languageData": [],
          "hidden": [],
          "uid": 255,
          "identifier": "WRAPPER"
        },
        {
          "id": 257,
          "pageId": 1,
          "widgetId": 1,
          "parentId": 1,
          "displayOrder": 7,
          "data": {
            "columnsNormal": "full-width",
            "name": "Section",
            "sectionTracker": 6
          },
          "permissions": [],
          "nodes": [],
          "content": [
            {
              "id": 393,
              "pageId": 1,
              "widgetId": 48,
              "parentId": 257,
              "displayOrder": 1,
              "data": {
                "col": 0,
                "emptyWriteTemplate": "",
                "name": "Other Valuable Benefits",
                "row": 0,
                "sizeX": 12,
                "toggle": 1
              },
              "permissions": [],
              "nodes": [],
              "content": [],
              "widget": 48,
              "languageData": [],
              "hidden": [],
              "uid": 393,
              "identifier": "OTHER-VALUABLE-BENEFITS"
            }
          ],
          "widget": 1,
          "languageData": [],
          "hidden": [],
          "uid": 257,
          "identifier": "WRAPPER"
        }
      ],
      "widget": 1,
      "languageData": [],
      "hidden": [],
      "uid": 1,
      "identifier": "WRAPPER"
    }
  ],
  "children": [],
  "categories": [],
  "parents": [],
  "url": "default",
  "name": "Home",
  "description": "",
  "categoryNames": [],
  "hasChildren": false,
  "hidden": []
}
